import React from 'react';
export const FinalCTA = () => {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-14 px-4 relative z-10 border-t border-gold-dark/20 bg-mystic-surfaceDark/50" data-id="element-72">
      <div className="max-w-3xl mx-auto text-center" data-id="element-73">
        <div className="text-gold-primary text-2xl mb-4 tracking-[0.5em]" data-id="element-74">
          ☽ ◯ ☾
        </div>

        <h2 className="font-cormorant text-5xl md:text-6xl text-text-primary mb-4" data-id="element-75">
          Dejá de dar vueltas.
        </h2>
        <h3 className="font-cormorant text-3xl text-gold-light italic mb-6" data-id="element-76">
          Tu camino empieza acá.
        </h3>

        <p className="text-xl text-text-soft mb-8 leading-relaxed" data-id="element-77">
          El Grimorio del Sur es la herramienta que te faltaba para dejar de
          buscar y empezar a practicar. Con estructura, con claridad, con lo que
          ya tenés.
        </p>

        <button onClick={scrollToPricing} className="btn-gold w-full md:w-auto px-10 py-5 rounded-full text-xl font-bold uppercase tracking-wide shadow-[0_0_40px_rgba(201,165,78,0.2)] mb-6" data-id="element-78">
          ACCEDER AL GRIMORIO AHORA
        </button>

        <div className="flex flex-wrap justify-center items-center gap-4 text-text-muted text-sm" data-id="element-79">
          <span className="flex items-center gap-1" data-id="element-80">🔒 Compra segura</span>
          <span className="hidden md:inline" data-id="element-81">|</span>
          <span className="flex items-center gap-1" data-id="element-82">📩 Acceso inmediato</span>
          <span className="hidden md:inline" data-id="element-83">|</span>
          <span className="flex items-center gap-1" data-id="element-84">🛡️ Garantía 7 días</span>
        </div>
      </div>
    </section>;
};